module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="popover ' +
((__t = ( data.className )) == null ? '' : __t) +
'" role="tooltip">\n    <div class="arrow"></div>\n    ';
 if (data.dismissable && data.showCloseButton) { ;
__p += '\n    <button type="button" class="close close-popover" data-dismiss="popover" aria-hidden="true">&times;</button>\n    ';
 } ;
__p += '\n    <h3 class="popover-title"></h3>\n    <div class="popover-content"></div>\n</div>\n';
return __p
}